import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=d6be07dc&"
import script from "./FormRegister.vue?vue&type=script&lang=js&"
export * from "./FormRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6be07dc')) {
      api.createRecord('d6be07dc', component.options)
    } else {
      api.reload('d6be07dc', component.options)
    }
    module.hot.accept("./FormRegister.vue?vue&type=template&id=d6be07dc&", function () {
      api.rerender('d6be07dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormRegister.vue"
export default component.exports